import { Store } from "./IStore";

export interface IStoreUpdateAuditResult {
  importedStoreNumbersAreUnique: boolean;
  existingStoreNumbersAreUnique: boolean;
  importRecordCountBelowLimit: boolean;
  importedStoreNumbersAreNotNull: boolean;
  success: boolean;
  importedStoreCount: number;
  storesToBeAdded: Store[];
  storesToBeUpdated: Store[];
  storesToBeRemoved: Store[];
}
